import script from "./LanguageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageModal.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageModal.vue?vue&type=style&index=0&id=582501f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582501f1"]])

export default __exports__